import CardRed from './CardRed';

class ComponentsCard {
  static CardRed = CardRed
}

export default ComponentsCard